import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { forkJoin } from 'rxjs';
import { AventuraService } from 'src/app/services/api/aventura.service';
import { FunctionsService } from 'src/app/services/api/functions.service';


@Component({
  selector: 'app-dialog-historial',
  templateUrl: './dialog-historial.component.html',
  styleUrls: ['./dialog-historial.component.css']
})

export class DialogHistorialComponent implements OnInit {

  displayedColumns: string[] = ['day', 'nombreServicio', 'tipoServicio', 'nombreProveedor', 'tipoProveedor'];
  dataOrder: any = null
  isLoading: boolean = false
  result: any

  constructor(public dialogRef: MatDialogRef<DialogHistorialComponent>, public dialog: MatDialog, private _liveAnnouncer: LiveAnnouncer, @Inject(MAT_DIALOG_DATA) public data: any, private service: AventuraService, private functionService: FunctionsService) { }

  @ViewChild(MatSort) sort: any;

  ngOnInit() {
    this.isLoading = true
    this.dataOrder = this.data.historial?.map((item: any) => JSON.parse(item))
    console.log(this.dataOrder)

    if (this.dataOrder) {
      const Observables = this.dataOrder?.map((item: { providerId: String; }) => this.service.getProvider(item.providerId))
      forkJoin(Observables).subscribe({
        next: (result: any) => {
          this.result = result
        },
        complete: () => {
          this.dataOrder = this.dataOrder.map((item: any, index: number) =>
            ({ ...item, nombreProveedor: this.result[index]?.getProvider?.nombre, tipoProveedor: this.result[index]?.getProvider?.tipoProveedor })
          )

          console.log(this.dataOrder)
          this.isLoading = false
        },

        error(err) {
          console.log(err)
        },
      })

    } else {
      this.isLoading = false
    }
  }

  close() {
    this.dialogRef.close();
  }


  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }




}
